import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { ResponseCollectionSpecialInfo } from '@shared/dto/collection/_requests/response_collection_images_ids_in_special_collections';
import { try_add_images_ids_to_special_collections } from '../_methods/try_add_images_ids_to_special_collections';
import { STATE__collections } from '../STATE__collections';

export const local_collection_special_info_upsert = (payload: ResponseCollectionSpecialInfo[]): PayloadAction<ResponseCollectionSpecialInfo[]> => ({
  type: ENUM__redux_action.COLLECTIONS_SPECIAL_INFO_UPSERT,
  payload,
});

export const init_local_collection_special_info_upsert = (state: STATE__collections, action: PayloadAction<ResponseCollectionSpecialInfo[]>) => {
  if (action.payload.is_empty()) return;

  for (let response of action.payload) {
    let { workspace_id, type, images_ids } = response;

    try_add_images_ids_to_special_collections(state, workspace_id, type, images_ids);
  }
};
